// extracted by mini-css-extract-plugin
module.exports = {"messageWrapper":"WithdrawalModals_messageWrapper__6L8kE","support":"WithdrawalModals_support__Sf9rY","closeIcon":"WithdrawalModals_closeIcon__wdmOv"};